import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Report } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_EXERCISE_REPORT_ID = 'get-exercise-report-id';

export const useGetExerciseReport = (
  exerciseSettingId: number,
  startDate: string,
  endDate: string,
) => {
  return usePermittedQuery<Report>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () =>
      `/submission/exercise/progress?startDate=${startDate}&endDate=${endDate}&exerciseSettingId=${exerciseSettingId}`,
    {},
    [GET_EXERCISE_REPORT_ID],
    {
      enabled: typeof exerciseSettingId === 'number' && exerciseSettingId >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
